import React from "react";
import { Table, Button, Spinner } from "reactstrap";
import { MdEdit, MdDelete } from "react-icons/lib/md";

/**
 * Componente TablaVehiculos para listar los vehículos registrados.
 *
 * @param {object} props
 * @param {Array} props.vehiculos - Lista de vehículos a mostrar
 * @param {boolean} props.isLoading - Flag de carga
 * @param {function} props.onEditar - Callback al presionar Editar
 * @param {function} props.onEliminar - Callback al presionar Eliminar
 */
const TablaVehiculos = ({ vehiculos, isLoading, onEditar, onEliminar }) => {
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner color="primary" />
        <span className="ml-3 font-weight-bold">Cargando vehículos...</span>
      </div>
    );
  }

  if (!vehiculos || vehiculos.length === 0) {
    return (
      <div className="text-center p-5 border rounded bg-light">
        <p className="lead text-muted mb-0">No se encontraron vehículos registrados.</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table hover responsive striped className="align-middle">
        <thead className="thead-light">
          <tr>
            <th className="text-center">Placa</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th className="text-center">Año</th>
            <th>Color</th>
            <th>Propietario</th>
            <th className="text-center" style={{ width: "150px" }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {vehiculos.map((vehiculo) => (
            <tr key={vehiculo.id}>
              <td className="align-middle text-center font-weight-bold text-primary">
                {vehiculo.placa}
              </td>
              <td className="align-middle">{vehiculo.marca}</td>
              <td className="align-middle">{vehiculo.modelo}</td>
              <td className="align-middle text-center">{vehiculo.anio}</td>
              <td className="align-middle">{vehiculo.color}</td>
              <td className="align-middle">{vehiculo.propietario || "—"}</td>
              <td className="align-middle text-center">
                <Button
                  color="info"
                  size="sm"
                  className="mr-2 btn-icon"
                  title="Editar vehículo"
                  onClick={() => onEditar(vehiculo)}
                >
                  <MdEdit size={16} />
                </Button>
                <Button
                  color="danger"
                  size="sm"
                  className="btn-icon"
                  title="Eliminar vehículo"
                  onClick={() => onEliminar(vehiculo)}
                >
                  <MdDelete size={16} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TablaVehiculos;
